import { styled } from "styled-components";
import { m as Motion } from "framer-motion";

export const Arrow = styled.div`
  &,
  &::before {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    z-index: -1;
  }

  &::before {
    content: "";
    transform: rotate(45deg);
  }
`;

export const StyledTooltip = styled(Motion.div)`
  padding: 12px;
  font-size: 14px;
  border-radius: 12px;
  width: max-content;
  max-width: 320px;
  z-index: 101;
  // border: 2px solid gray;
  background: #332D3E; // ${({ theme }) => theme.tooltip.background};
  color: white; // ${({ theme }) => theme.tooltip.text};
  box-shadow: ${({ theme }) => theme.tooltip.boxShadow};
  box-shadow: 0px 1px 2px 0px #1018280A, 0px 25px 25px 0px #0000002B, 0px 55px 33px 0px #0000001A, 0px 98px 39px 0px #00000008, 0px 153px 43px 0px #00000000;

  &[data-popper-placement^="top"] > ${Arrow} {
    bottom: -4px;
  }

  &[data-popper-placement^="bottom"] > ${Arrow} {
    top: -4px;
  }

  &[data-popper-placement^="left"] > ${Arrow} {
    right: -4px;
  }

  &[data-popper-placement^="right"] > ${Arrow} {
    left: -4px;
  }
` as typeof Motion.div;
